import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const rukamiComplexItems = [
    {
        img: '/images/svg/rukami/timing.svg',
        text: `Сжатые сроки: <span class="rukami-complex__text-bold">6 месяцев</span> на объем работ, которые обычно занимают около года`,
    },
    {
        img: '/images/svg/rukami/platform.svg',
        text: 'Разработка высоконагруженной платформы с&nbsp;высокой степенью отказоустойчивости',
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} className="rukami-complex" isMargin={false}>
                <CommonTitle>Сложности</CommonTitle>
                <div className="rukami-complex__content">
                    {rukamiComplexItems.map(({ img, text }, index) => (
                        <div key={index} className="rukami-complex__item">
                            <img
                                className="rukami-complex__img"
                                src={img}
                                alt=""
                                aria-hidden="true"
                                loading="lazy"
                            />
                            <CommonSmallText>{parse(text)}</CommonSmallText>
                        </div>
                    ))}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
